import { useEffect, useState } from "react";
import { listUsers } from "../../../../../util/APIUtils";
import { USER_CONTEXT } from "../../../../../constants";
import { getContactDetails, manageCallContacts } from "../../services/call.service";

export const useManageContactHook = ({ userId, locationId, isAddVideoContactOpen, onClose }) => {
    const [residents, setResidents] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const INITIAL_VALUES = {
        resident: null,
        firstName: "",
        lastName: "",
        relationship: null,
        language: null,
        phoneNumber: "",
        email: "",
        file: null // This will be handled by the selectedFile state
    };
    const [initialValues, setInitialValues] = useState(INITIAL_VALUES);

    useEffect(() => {
        if (isAddVideoContactOpen) {
            if (userId) {
                getUserDetail(userId);
            } else { //FETCH ONLY IF ITS CREATE CONTACT
                getAllResidents();
            }
        }
    }, [isAddVideoContactOpen, userId]);

    const getAllResidents = async () => {
        setIsLoading(true);
        try {
            let postBody = {
                requestorId: USER_CONTEXT.personId,
                requestorLocationId: '',
                filterLocationTypeIds: [],
                filterRoleTypeIds: [19, 30],
                filterLocationIds: [locationId],
                filterUserStatus: 'active'
            };

            const users = await listUsers(postBody);
            setResidents(users.users.map(
                user => ({
                    label: user.userName,
                    value: user.personId
                })
            ));
        } catch (error) {
            console.error('Error fetching residents:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const onCloseHandler = () => {
        setInitialValues(() => INITIAL_VALUES);
        onClose();
    }; 

    const onSubmitHandler = (formData, isEdit) => {
        return manageCallContacts({
            ...formData,
            locationId
        }, isEdit);
    };

    const getUserDetail = async (userId) => {
        setIsLoading(true);
        try {
            setInitialValues(initialValues => ({
                id: 1234, //DUMMY ID IN ORDER TO INVOKE isEdit W/O WAITING
                ...initialValues
            }));
            const response = await getContactDetails(userId);
            setInitialValues(response);
        } catch (error) {
            console.error('Error fetching user details:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return {
        initialValues,
        isLoading,
        residents,
        onSubmitHandler,
        onCloseHandler
    };
};
